import React from "react";

const SaveForLaterModal = ({ isOpen, onClose, onSaveDraft }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop with blur and dark opacity */}
      <div className="absolute inset-0 bg-gray-900 opacity-50 backdrop-filter backdrop-blur-sm z-40"></div>

      {/* Modal content */}
      <div className="bg-white rounded-lg shadow-lg max-w-md w-full p-6 z-50">
        <h2 className="text-lg font-semibold text-center">Save this event for later?</h2>
        <p className="text-sm mb-4 text-center">
          You&apos;re about to save your draft. Are you sure you want to do this?
        </p>
        <div className="flex justify-center space-x-4">
          <button
            type="button"
            onClick={onClose}
            className="bg-white text-[#101828] border border-gray-300 rounded-lg px-4 py-3 shadow-sm hover:bg-gray-50 text-base flex items-center justify-center"
          >
            No, Go Back
          </button>
          <button
            type="button"
            onClick={() => {
              onSaveDraft();
              onClose();
            }}
            className="shadow-[0px_1px_2px_rgba(16,_24,_40,_0.05)] rounded-lg bg-[#344054] flex items-center justify-center py-3 px-4 text-base text-[#fcfcfd]"
          >
            Yes, Save As Draft
          </button>
        </div>
      </div>
    </div>
  );
};

export default SaveForLaterModal;
